function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireed96"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireed96"] = parcelRequire;
}
parcelRequire.register("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $18c11f3350a906ea$export$f7ad0328861e2f03, (v) => $18c11f3350a906ea$export$f7ad0328861e2f03 = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = {};
function $18c11f3350a906ea$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$18c11f3350a906ea$var$mapping[keys[i]] = pairs[keys[i]];
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $a5d90bf4f39bc487$exports = {};

(parcelRequire("27Lyk")).register(JSON.parse('{"1LzKV":"index.ec5a4b7d.js","a2Cve":"process.8010e3f6.js","bj76Q":"flash.7ae5cfb8.svg","e0Dy9":"flash-off.f95884b2.svg","lX2gi":"hd.0cfe4ff9.svg","gltHY":"sd.25c2f123.svg","drXuR":"service.js"}'));

var $c75b7671c945b972$exports = {};
var $56b621a6dd25b2cb$exports = {};
"use strict";
$56b621a6dd25b2cb$exports = function(workerUrl, origin, isESM) {
    if (origin === self.location.origin) // If the worker bundle's url is on the same origin as the document,
    // use the worker bundle's own url.
    return workerUrl;
    else {
        // Otherwise, create a blob URL which loads the worker bundle with `importScripts`.
        var source = isESM ? "import " + JSON.stringify(workerUrl) + ";" : "importScripts(" + JSON.stringify(workerUrl) + ");";
        return URL.createObjectURL(new Blob([
            source
        ], {
            type: "application/javascript"
        }));
    }
};



let $c75b7671c945b972$var$url = new URL((parcelRequire("27Lyk")).resolve("a2Cve"), import.meta.url);
$c75b7671c945b972$exports = $56b621a6dd25b2cb$exports($c75b7671c945b972$var$url.toString(), $c75b7671c945b972$var$url.origin, true);


const $191e7775e3189472$var$newWorker = ()=>new Worker($c75b7671c945b972$exports);
const $191e7775e3189472$var$processWorkers = [];
if (navigator.hardwareConcurrency) for(let i = 1; i < navigator.hardwareConcurrency; ++i)$191e7775e3189472$var$processWorkers.push($191e7775e3189472$var$newWorker());
const $191e7775e3189472$var$getWorker = ()=>$191e7775e3189472$var$processWorkers.pop() || $191e7775e3189472$var$newWorker();
const $191e7775e3189472$var$returnWorker = (worker)=>$191e7775e3189472$var$processWorkers.push(worker);
let $191e7775e3189472$var$messageID = 0;
const $191e7775e3189472$var$message = async (msg, transfer)=>{
    return new Promise((resolve, reject)=>{
        const worker = $191e7775e3189472$var$getWorker();
        let id = $191e7775e3189472$var$messageID++;
        // const ts = performance.now();
        const onMessage = (evt)=>{
            const { id: mid, error: error, result: result } = evt.data;
            if (mid == id) {
                if (error) {
                    let err = new Error(error.message);
                    err.stack = error.stack;
                    err.name = error.name;
                    reject(err);
                } else resolve(result);
                // console.log('Processed', msg, 'in', (performance.now() - ts) + 'ms', { result, error });
                $191e7775e3189472$var$returnWorker(worker);
                worker.removeEventListener("message", onMessage);
            }
        };
        worker.addEventListener("message", onMessage);
        worker.postMessage({
            id: id,
            msg: msg
        }, transfer || []);
    });
};
function $191e7775e3189472$export$c5fefc891e91de4b(data, transfer) {
    return $191e7775e3189472$var$message({
        type: "find-document",
        data: data
    }, transfer ? [
        data.data.buffer
    ] : []);
}
function $191e7775e3189472$export$ab8ba24d4c0c8986(data, region, targetWidth, transfer) {
    return $191e7775e3189472$var$message({
        type: "extract-document",
        data: data,
        region: region,
        targetWidth: targetWidth
    }, transfer ? [
        data.data.buffer
    ] : []);
}
function $191e7775e3189472$export$6806abd6abc725de(bitmap, transfer) {
    return $191e7775e3189472$var$message({
        type: "get-data",
        bitmap: bitmap
    }, transfer ? [
        bitmap
    ] : []);
}


const $98ce8732f7dffb75$var$readFile = Blob.prototype.arrayBuffer || function() {
    return new Promise((resolve, reject)=>{
        const fr = new FileReader();
        fr.onload = ()=>{
            resolve(fr.result);
        };
        fr.onerror = ()=>{
            reject(fr.error);
        };
        fr.readAsArrayBuffer(this);
    });
};
const $98ce8732f7dffb75$export$99fdcdff3bb1ad24 = async (images)=>{
    const pdfChunks = [];
    let index = 0;
    const offsets = [];
    const write = (chunk)=>{
        pdfChunks.push(chunk);
        index += chunk.length;
    };
    const token = (chunk)=>{
        write(" ");
        write(chunk);
    };
    const concat = (chunks)=>{
        let len = 0;
        for (const chunk of chunks)len += chunk.length;
        const buf = new Uint8Array(len);
        len = 0;
        for (const chunk of chunks){
            if (typeof chunk == "string") for(let i = 0; i < chunk.length; ++i)buf[i + len] = chunk.charCodeAt(i);
            else buf.set(chunk, len);
            len += chunk.length;
        }
        return buf;
    };
    // Convenience functions
    const comment = (content)=>{
        write("%" + content + "\n");
    };
    const number = (value)=>{
        // Note: this doesnt work for very small and very large numbers
        token(value.toString());
    };
    const ascii = (value)=>{
        token("(" + value.replace(/[\n\r\t\f\b\(\)\\]/g, (c)=>"\\00" + c.charCodeAt(0).toString(8)) + ")");
    };
    const bin = (value)=>{
        let data = "<";
        if (typeof value == "string") for(let i = 0; i < value.length; ++i)data += value.charCodeAt(i).toString(16);
        else for(let i = 0; i < value.length; ++i)data += value[i].toString(16);
        token(data + ">");
    };
    const name = (value)=>{
        // Note: only supports ASCII names
        token("/" + value);
    };
    const array = (fn)=>{
        token("[");
        fn();
        token("]");
    };
    const dict = (values)=>{
        token("<<");
        for(const key in values){
            name(key);
            values[key]();
        }
        token(">>");
    };
    const stream = (desc, content)=>{
        dict(desc);
        token("stream\n");
        write(content);
        write("endstream");
    };
    const object = (fn)=>{
        write(" ");
        write(offsets.push(index) + " 0 obj");
        fn();
        token("endobj");
        return offsets.length;
    };
    const reference = (id)=>{
        token(id + " 0 R");
    };
    const nullObject = ()=>{
        token("null");
    };
    // v1.4 for compatibility
    comment("PDF-1.4");
    // 4 byte binary comment, as suggested by spec
    comment("\x90\x85\xfa\xe3");
    const pages = await Promise.all(images.map(async (img)=>{
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        canvas.getContext("2d").putImageData(img, 0, 0);
        const jpeg = await new Promise((resolve)=>canvas.toBlob(resolve, "image/jpeg"));
        const jpegData = new Uint8Array(await $98ce8732f7dffb75$var$readFile.call(jpeg));
        const image = object(()=>{
            stream({
                Type () {
                    name("XObject");
                },
                Subtype () {
                    name("Image");
                },
                Width () {
                    number(img.width);
                },
                Height () {
                    number(img.height);
                },
                ColorSpace () {
                    name("DeviceRGB");
                },
                BitsPerComponent () {
                    number(8);
                },
                Filter () {
                    name("DCTDecode");
                },
                Length () {
                    number(jpegData.length);
                }
            }, jpegData);
        });
        // US Letter width
        const height = 792;
        const width = height * img.width / img.height;
        const contents = object(()=>{
            const result = `${width} 0 0 ${height} 0 0 cm /I Do`;
            stream({
                Length () {
                    number(result.length);
                }
            }, concat([
                result
            ]));
        });
        const page = object(()=>{
            dict({
                Type () {
                    name("Page");
                },
                Parent () {
                    reference(offsets.length + 1);
                },
                Resources () {
                    dict({
                        XObject () {
                            dict({
                                I () {
                                    reference(image);
                                }
                            });
                        }
                    });
                },
                Contents () {
                    reference(contents);
                },
                MediaBox () {
                    array(()=>{
                        number(0);
                        number(0);
                        number(width);
                        number(height);
                    });
                }
            });
        });
        return page;
    }));
    const pageRoot = object(()=>{
        dict({
            Type () {
                name("Pages");
            },
            Kids () {
                array(()=>{
                    for (const page of pages)reference(page);
                });
            },
            Count () {
                number(pages.length);
            }
        });
    });
    const catalog = object(()=>{
        dict({
            Type () {
                name("Catalog");
            },
            Pages () {
                reference(pageRoot);
            }
        });
    });
    // XREF
    write("\n");
    const xrefOffset = index;
    write("xref\n0 " + (offsets.length + 1) + "\n0000000000 65535 f \n");
    for (const offset of offsets)write(offset.toString().padStart(10, "0") + " 00000 n \n");
    write("trailer");
    dict({
        Size () {
            number(offsets.length + 1);
        },
        Root () {
            reference(catalog);
        }
    });
    write("\nstartxref\n" + xrefOffset + "\n%%EOF");
    return concat(pdfChunks);
};



const $aa7f0fbc084e0a0e$export$85ada9a21afbeab6 = async (img)=>{
    const elem = document.createElement("img");
    const loaded = new Promise((resolve, reject)=>{
        elem.onload = ()=>{
            resolve();
        };
        elem.onerror = (err)=>{
            reject(err);
        };
    });
    elem.src = URL.createObjectURL(img);
    await loaded;
    URL.revokeObjectURL(elem.src);
    return elem;
};
const $aa7f0fbc084e0a0e$var$sharedCanvas = document.createElement("canvas");
const $aa7f0fbc084e0a0e$var$sharedCtx = $aa7f0fbc084e0a0e$var$sharedCanvas.getContext("2d");
const $aa7f0fbc084e0a0e$export$7a171f172be0782e = async (img, transfer)=>{
    if ($aa7f0fbc084e0a0e$var$sharedCanvas["transferControlToOffscreen"]) return (0, $191e7775e3189472$export$6806abd6abc725de)(img instanceof ImageBitmap ? img : await createImageBitmap(img), transfer);
    $aa7f0fbc084e0a0e$var$sharedCanvas.width = img.width, $aa7f0fbc084e0a0e$var$sharedCanvas.height = img.height;
    $aa7f0fbc084e0a0e$var$sharedCtx.drawImage(img, 0, 0);
    return $aa7f0fbc084e0a0e$var$sharedCtx.getImageData(0, 0, img.width, img.height);
};
const $aa7f0fbc084e0a0e$export$24422be91ad4011f = (file, name)=>{
    const url = URL.createObjectURL(file);
    const el = document.createElement("a");
    el.download = name;
    el.href = url;
    el.click();
    URL.revokeObjectURL(url);
};


var $5680d29e5f9eab67$exports = {};

$5680d29e5f9eab67$exports = new URL((parcelRequire("27Lyk")).resolve("bj76Q"), import.meta.url).toString();


var $bb74cf2efca2bea5$exports = {};

$bb74cf2efca2bea5$exports = new URL((parcelRequire("27Lyk")).resolve("e0Dy9"), import.meta.url).toString();


var $009ec47ee18c0b40$exports = {};

$009ec47ee18c0b40$exports = new URL((parcelRequire("27Lyk")).resolve("lX2gi"), import.meta.url).toString();


var $954630f75b1da243$exports = {};

$954630f75b1da243$exports = new URL((parcelRequire("27Lyk")).resolve("gltHY"), import.meta.url).toString();


/**
 * MediaStream ImageCapture polyfill
 *
 * @license
 * Copyright 2018 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $0e4bd8b916ae6e46$export$d2caa7debd66c3ef = window.ImageCapture;
if (typeof $0e4bd8b916ae6e46$export$d2caa7debd66c3ef === "undefined") $0e4bd8b916ae6e46$export$d2caa7debd66c3ef = class {
    /**
     * TODO https://www.w3.org/TR/image-capture/#constructors
     *
     * @param {MediaStreamTrack} videoStreamTrack - A MediaStreamTrack of the 'video' kind
     */ constructor(videoStreamTrack){
        if (videoStreamTrack.kind !== "video") throw new DOMException("NotSupportedError");
        this._videoStreamTrack = videoStreamTrack;
        if (!("readyState" in this._videoStreamTrack)) // Polyfill for Firefox
        this._videoStreamTrack.readyState = "live";
        // MediaStream constructor not available until Chrome 55 - https://www.chromestatus.com/feature/5912172546752512
        this._previewStream = new MediaStream([
            videoStreamTrack
        ]);
        this.videoElement = document.createElement("video");
        this.videoElementPlaying = new Promise((resolve)=>{
            this.videoElement.addEventListener("playing", resolve);
        });
        if (HTMLMediaElement) this.videoElement.srcObject = this._previewStream; // Safari 11 doesn't allow use of createObjectURL for MediaStream
        else this.videoElement.src = URL.createObjectURL(this._previewStream);
        this.videoElement.muted = true;
        this.videoElement.setAttribute("playsinline", ""); // Required by Safari on iOS 11. See https://webkit.org/blog/6784
        this.videoElement.play();
        this.canvasElement = document.createElement("canvas");
        // TODO Firefox has https://developer.mozilla.org/en-US/docs/Web/API/OffscreenCanvas
        this.canvas2dContext = this.canvasElement.getContext("2d");
    }
    /**
     * https://w3c.github.io/mediacapture-image/index.html#dom-imagecapture-videostreamtrack
     * @return {MediaStreamTrack} The MediaStreamTrack passed into the constructor
     */ get videoStreamTrack() {
        return this._videoStreamTrack;
    }
    /**
     * Implements https://www.w3.org/TR/image-capture/#dom-imagecapture-getphotocapabilities
     * @return {Promise<PhotoCapabilities>} Fulfilled promise with
     * [PhotoCapabilities](https://www.w3.org/TR/image-capture/#idl-def-photocapabilities)
     * object on success, rejected promise on failure
     */ getPhotoCapabilities() {
        return new Promise(function executorGPC(resolve, reject) {
            // TODO see https://github.com/w3c/mediacapture-image/issues/97
            const MediaSettingsRange = {
                current: 0,
                min: 0,
                max: 0
            };
            resolve({
                exposureCompensation: MediaSettingsRange,
                exposureMode: "none",
                fillLightMode: "none",
                focusMode: "none",
                imageHeight: MediaSettingsRange,
                imageWidth: MediaSettingsRange,
                iso: MediaSettingsRange,
                redEyeReduction: false,
                whiteBalanceMode: "none",
                zoom: MediaSettingsRange
            });
            reject(new DOMException("OperationError"));
        });
    }
    /**
     * Implements https://www.w3.org/TR/image-capture/#dom-imagecapture-setoptions
     * @param {Object} photoSettings - Photo settings dictionary, https://www.w3.org/TR/image-capture/#idl-def-photosettings
     * @return {Promise<void>} Fulfilled promise on success, rejected promise on failure
     */ setOptions(photoSettings = {}) {
        return new Promise(function executorSO(resolve, reject) {
        // TODO
        });
    }
    /**
     * TODO
     * Implements https://www.w3.org/TR/image-capture/#dom-imagecapture-takephoto
     * @return {Promise<Blob>} Fulfilled promise with [Blob](https://www.w3.org/TR/FileAPI/#blob)
     * argument on success; rejected promise on failure
     */ takePhoto() {
        const self = this;
        return new Promise(function executorTP(resolve, reject) {
            // `If the readyState of the MediaStreamTrack provided in the constructor is not live,
            // return a promise rejected with a new DOMException whose name is "InvalidStateError".`
            if (self._videoStreamTrack.readyState !== "live") return reject(new DOMException("InvalidStateError"));
            self.videoElementPlaying.then(()=>{
                try {
                    self.canvasElement.width = self.videoElement.videoWidth;
                    self.canvasElement.height = self.videoElement.videoHeight;
                    self.canvas2dContext.drawImage(self.videoElement, 0, 0);
                    self.canvasElement.toBlob(resolve);
                } catch (error) {
                    reject(new DOMException("UnknownError"));
                }
            });
        });
    }
    /**
     * Implements https://www.w3.org/TR/image-capture/#dom-imagecapture-grabframe
     * @return {Promise<ImageBitmap>} Fulfilled promise with
     * [ImageBitmap](https://www.w3.org/TR/html51/webappapis.html#webappapis-images)
     * argument on success; rejected promise on failure
     */ grabFrame() {
        const self = this;
        return new Promise(function executorGF(resolve, reject) {
            // `If the readyState of the MediaStreamTrack provided in the constructor is not live,
            // return a promise rejected with a new DOMException whose name is "InvalidStateError".`
            if (self._videoStreamTrack.readyState !== "live") return reject(new DOMException("InvalidStateError"));
            self.videoElementPlaying.then(()=>{
                try {
                    self.canvasElement.width = self.videoElement.videoWidth;
                    self.canvasElement.height = self.videoElement.videoHeight;
                    self.canvas2dContext.drawImage(self.videoElement, 0, 0);
                    // TODO polyfill https://developer.mozilla.org/en-US/docs/Web/API/ImageBitmapFactories/createImageBitmap for IE
                    resolve(window.createImageBitmap(self.canvasElement));
                } catch (error) {
                    reject(new DOMException("UnknownError"));
                }
            });
        });
    }
};
window.ImageCapture = $0e4bd8b916ae6e46$export$d2caa7debd66c3ef;


const $b4e14b6b8da86996$var$root = document.getElementById("root");
const $b4e14b6b8da86996$var$modal = document.getElementById("modal");
const $b4e14b6b8da86996$var$captures = document.getElementById("captures");
const $b4e14b6b8da86996$var$preview = document.getElementById("preview");
const $b4e14b6b8da86996$var$previewCrop = document.getElementById("preview-crop");
const $b4e14b6b8da86996$var$previewDoc = document.getElementById("preview-doc");
const $b4e14b6b8da86996$var$bottomWrapper = document.getElementById("bottom-wrapper");
const $b4e14b6b8da86996$var$topWrapper = document.getElementById("top-wrapper");
const $b4e14b6b8da86996$var$selectWrapper = document.getElementById("camera-select-wrapper");
const $b4e14b6b8da86996$var$select = document.getElementById("camera-select");
const $b4e14b6b8da86996$var$qualityWrapper = document.getElementById("quality-wrapper");
const $b4e14b6b8da86996$var$quality = document.getElementById("quality");
const $b4e14b6b8da86996$var$qualityImg = document.getElementById("quality-img");
const $b4e14b6b8da86996$var$githubWrapper = document.getElementById("github-wrapper");
const $b4e14b6b8da86996$var$flashWrapper = document.getElementById("flash-wrapper");
const $b4e14b6b8da86996$var$flash = document.getElementById("flash");
const $b4e14b6b8da86996$var$flashImg = document.getElementById("flash-img");
const $b4e14b6b8da86996$var$pastWrapper = document.getElementById("past-wrapper");
const $b4e14b6b8da86996$var$past = document.getElementById("past");
const $b4e14b6b8da86996$var$uploadWrapper = document.getElementById("upload-wrapper");
const $b4e14b6b8da86996$var$upload = document.getElementById("upload");
const $b4e14b6b8da86996$var$shutter = document.getElementById("shutter");
const $b4e14b6b8da86996$var$doneWrapper = document.getElementById("done-wrapper");
const $b4e14b6b8da86996$var$done = document.getElementById("done");
const $b4e14b6b8da86996$var$modalBottomWrapper = document.getElementById("modal-bottom-wrapper");
const $b4e14b6b8da86996$var$modalCancelWrapper = document.getElementById("modal-cancel-wrapper");
const $b4e14b6b8da86996$var$modalCancel = document.getElementById("modal-cancel");
const $b4e14b6b8da86996$var$modalDoneWrapper = document.getElementById("modal-done-wrapper");
const $b4e14b6b8da86996$var$modalDone = document.getElementById("modal-done");
let $b4e14b6b8da86996$var$defaultMaxRes;
let $b4e14b6b8da86996$var$maxRes = {};
const $b4e14b6b8da86996$var$pages = [];
const $b4e14b6b8da86996$var$log = (text)=>{
    const el = document.createElement("div");
    el.innerText = text;
    $b4e14b6b8da86996$var$root.appendChild(el);
};
const $b4e14b6b8da86996$var$resizeListeners = [];
const $b4e14b6b8da86996$var$onResize = (listener)=>{
    $b4e14b6b8da86996$var$resizeListeners.push(listener);
    return ()=>{
        $b4e14b6b8da86996$var$resizeListeners.splice($b4e14b6b8da86996$var$resizeListeners.indexOf(listener), 1);
    };
};
const $b4e14b6b8da86996$var$callResizeListeners = ()=>{
    for (const listener of $b4e14b6b8da86996$var$resizeListeners)listener();
};
let $b4e14b6b8da86996$var$rst = -1;
window.addEventListener("resize", ()=>{
    clearTimeout($b4e14b6b8da86996$var$rst);
    $b4e14b6b8da86996$var$rst = setTimeout($b4e14b6b8da86996$var$callResizeListeners, 250);
}, {
    passive: true
});
const $b4e14b6b8da86996$var$getMaxRes = (device)=>{
    const constraints = {
        width: 100000,
        height: 100000,
        facingMode: "environment"
    };
    if (device) {
        if ($b4e14b6b8da86996$var$maxRes[device]) return $b4e14b6b8da86996$var$maxRes[device];
        constraints.deviceId = {
            exact: device
        };
    } else if ($b4e14b6b8da86996$var$defaultMaxRes) return $b4e14b6b8da86996$var$defaultMaxRes;
    const prom = navigator.mediaDevices.getUserMedia({
        video: constraints
    }).then((media)=>{
        const settings = media.getVideoTracks()[0].getSettings();
        for (const track of media.getTracks())track.stop();
        const width = Math.max(settings.width, settings.height);
        const height = Math.min(settings.width, settings.height);
        return {
            width: width,
            height: height,
            deviceId: settings.deviceId
        };
    });
    if (device) $b4e14b6b8da86996$var$maxRes[device] = prom;
    else $b4e14b6b8da86996$var$defaultMaxRes = prom.then((val)=>{
        $b4e14b6b8da86996$var$maxRes[val.deviceId] = prom;
        return val;
    });
    return prom;
};
const $b4e14b6b8da86996$var$point = (a, scale)=>{
    const elem = document.createElement("div");
    const mwh = Math.min(window.innerWidth, window.innerHeight);
    elem.style.width = mwh * 0.03 + "px";
    elem.style.height = mwh * 0.03 + "px";
    elem.style.borderRadius = mwh * 0.015 + "px";
    elem.style.backgroundColor = "black";
    elem.style.position = "absolute";
    $b4e14b6b8da86996$var$adjustPoint(elem, a, scale);
    return elem;
};
const $b4e14b6b8da86996$var$adjustPoint = (elem, a, scale)=>{
    const mwh = Math.min(window.innerWidth, window.innerHeight);
    elem.style.top = a.y * scale - mwh * 0.015 + "px";
    elem.style.left = a.x * scale - mwh * 0.015 + "px";
};
const $b4e14b6b8da86996$var$line = (a, b, scale)=>{
    const elem = document.createElement("div");
    elem.style.height = "4px";
    elem.style.backgroundColor = "red";
    elem.style.position = "absolute";
    elem.style.transformOrigin = "center left";
    $b4e14b6b8da86996$var$adjustLine(elem, a, b, scale);
    return elem;
};
const $b4e14b6b8da86996$var$adjustLine = (elem, a, b, scale)=>{
    elem.style.width = Math.hypot(a.x - b.x, a.y - b.y) * scale + "px";
    elem.style.top = a.y * scale + "px";
    elem.style.left = a.x * scale + "px";
    elem.style.transform = `rotate(${Math.atan2(b.y - a.y, b.x - a.x)}rad)`;
};
const $b4e14b6b8da86996$var$preprocessPhoto = async (src)=>{
    let img, data;
    if (src instanceof Blob) {
        const image = await (0, $aa7f0fbc084e0a0e$export$85ada9a21afbeab6)(src);
        img = image;
        data = await (0, $aa7f0fbc084e0a0e$export$7a171f172be0782e)(image);
    } else {
        const cnv = document.createElement("canvas");
        cnv.width = src.width;
        cnv.height = src.height;
        cnv.getContext("2d").drawImage(src, 0, 0);
        img = cnv;
        data = await (0, $aa7f0fbc084e0a0e$export$7a171f172be0782e)(src, true);
    }
    const quad = await (0, $191e7775e3189472$export$c5fefc891e91de4b)(data) || {
        a: {
            x: 0,
            y: data.height
        },
        b: {
            x: 0,
            y: 0
        },
        c: {
            x: data.width,
            y: 0
        },
        d: {
            x: data.width,
            y: data.height
        }
    };
    const clampPoint = (a)=>{
        if (a.x < 0) a.x = 0;
        else if (a.x > data.width) a.x = data.width;
        if (a.y < 0) a.y = 0;
        else if (a.y > data.height) a.y = data.height;
    };
    clampPoint(quad.a);
    clampPoint(quad.b);
    clampPoint(quad.c);
    clampPoint(quad.d);
    return {
        img: img,
        data: data,
        quad: quad
    };
};
const $b4e14b6b8da86996$var$processPhotos = async (srcs)=>{
    const results = srcs.map((src)=>src instanceof Blob || src instanceof ImageBitmap ? $b4e14b6b8da86996$var$preprocessPhoto(src) : src);
    const cbs = [];
    let firstDimensions = {
        width: 0,
        height: 0
    };
    let landscape = false;
    for (const result of results){
        const isFirst = result == results[0];
        const isLast = result == results[results.length - 1];
        const { img: img, data: data, quad: quad } = await result;
        const imgCrop = document.createElement("div");
        imgCrop.style.display = "flex";
        imgCrop.style.justifyContent = "center";
        imgCrop.style.alignItems = "center";
        imgCrop.style.overflow = "hidden";
        imgCrop.style.scrollSnapAlign = "center";
        const imgDoc = document.createElement("div");
        imgDoc.style.position = "relative";
        imgDoc.appendChild(img);
        imgCrop.appendChild(imgDoc);
        $b4e14b6b8da86996$var$modal.style.display = "flex";
        const aspectRatio = Math.max(data.width, data.height) / Math.min(data.width, data.height);
        let scale = 0, docX = 0, docY = 0, latestDims = false;
        let prevElems = [];
        const getLatestDims = ()=>{
            if (!latestDims) {
                const { left: left, top: top } = imgDoc.getBoundingClientRect();
                docX = left;
                docY = top;
                latestDims = true;
            }
        };
        const makePoint = (src, onUpdate)=>{
            const pt = $b4e14b6b8da86996$var$point(src, scale);
            let active = false;
            const onDown = (evt, x, y)=>{
                if (pt.parentElement == imgDoc) {
                    if (evt.target == pt || evt.target == img && Math.hypot(x - src.x * scale, y - src.y * scale) < Math.min(window.innerWidth, window.innerHeight) * 0.2) {
                        evt.stopImmediatePropagation();
                        active = true;
                        onMove(x, y);
                    }
                } else {
                    imgDoc.removeEventListener("mousedown", onMouseDown);
                    imgDoc.removeEventListener("touchstart", onTouchStart);
                    imgDoc.removeEventListener("mousemove", onMouseMove);
                    imgDoc.removeEventListener("touchmove", onTouchMove);
                    imgDoc.removeEventListener("mouseup", onUp);
                    imgDoc.removeEventListener("touchend", onUp);
                }
            };
            const onMove = (x, y)=>{
                src.x = x / scale;
                src.y = y / scale;
                $b4e14b6b8da86996$var$adjustPoint(pt, src, scale);
                onUpdate();
            };
            const onUp = ()=>{
                active = false;
            };
            const onMouseDown = (e)=>{
                getLatestDims();
                onDown(e, e.pageX - docX, e.pageY - docY);
            };
            imgDoc.addEventListener("mousedown", onMouseDown);
            const onTouchStart = (e)=>{
                const touch = e.targetTouches[0];
                getLatestDims();
                onDown(e, touch.pageX - docX, touch.pageY - docY);
            };
            imgDoc.addEventListener("touchstart", onTouchStart);
            const onMouseMove = (e)=>{
                if (active) {
                    e.preventDefault();
                    onMove(e.pageX - docX, e.pageY - docY);
                }
            };
            imgDoc.addEventListener("mousemove", onMouseMove);
            const onTouchMove = (e)=>{
                if (active) {
                    const touch = e.targetTouches[0];
                    e.preventDefault();
                    onMove(touch.pageX - docX, touch.pageY - docY);
                }
            };
            imgDoc.addEventListener("touchmove", onTouchMove);
            imgDoc.addEventListener("mouseup", onUp);
            imgDoc.addEventListener("touchend", onUp);
            return pt;
        };
        const paintLines = ()=>{
            for (const elem of prevElems)imgDoc.removeChild(elem);
            const ab = $b4e14b6b8da86996$var$line(quad.a, quad.b, scale);
            const bc = $b4e14b6b8da86996$var$line(quad.b, quad.c, scale);
            const cd = $b4e14b6b8da86996$var$line(quad.c, quad.d, scale);
            const da = $b4e14b6b8da86996$var$line(quad.d, quad.a, scale);
            prevElems = [
                imgDoc.appendChild(ab),
                imgDoc.appendChild(bc),
                imgDoc.appendChild(cd),
                imgDoc.appendChild(da),
                imgDoc.appendChild(makePoint(quad.a, ()=>{
                    $b4e14b6b8da86996$var$adjustLine(da, quad.d, quad.a, scale);
                    $b4e14b6b8da86996$var$adjustLine(ab, quad.a, quad.b, scale);
                })),
                imgDoc.appendChild(makePoint(quad.b, ()=>{
                    $b4e14b6b8da86996$var$adjustLine(ab, quad.a, quad.b, scale);
                    $b4e14b6b8da86996$var$adjustLine(bc, quad.b, quad.c, scale);
                })),
                imgDoc.appendChild(makePoint(quad.c, ()=>{
                    $b4e14b6b8da86996$var$adjustLine(bc, quad.b, quad.c, scale);
                    $b4e14b6b8da86996$var$adjustLine(cd, quad.c, quad.d, scale);
                })),
                imgDoc.appendChild(makePoint(quad.d, ()=>{
                    $b4e14b6b8da86996$var$adjustLine(cd, quad.c, quad.d, scale);
                    $b4e14b6b8da86996$var$adjustLine(da, quad.d, quad.a, scale);
                }))
            ];
        };
        const updateImageDimensions = ()=>{
            const { width: width, height: height } = isFirst ? $b4e14b6b8da86996$var$calcDimensions(aspectRatio, 0.925) : firstDimensions;
            if (isFirst) {
                landscape = $b4e14b6b8da86996$var$isLandscape(aspectRatio);
                firstDimensions = {
                    width: width,
                    height: height
                };
                $b4e14b6b8da86996$var$modalCancelWrapper.style.width = $b4e14b6b8da86996$var$modalCancelWrapper.style.height = $b4e14b6b8da86996$var$modalDoneWrapper.style.width = $b4e14b6b8da86996$var$modalDoneWrapper.style.height = (landscape ? window.innerWidth : window.innerHeight) * 0.035 + "px";
                $b4e14b6b8da86996$var$modalCancelWrapper.style.margin = $b4e14b6b8da86996$var$modalDoneWrapper.style.margin = (landscape ? window.innerWidth : window.innerHeight) * 0.02 + "px";
                $b4e14b6b8da86996$var$captures.style.width = $b4e14b6b8da86996$var$modal.style.width = window.innerWidth + "px";
                $b4e14b6b8da86996$var$captures.style.height = $b4e14b6b8da86996$var$modal.style.height = window.innerHeight + "px";
                $b4e14b6b8da86996$var$modal.style.flexDirection = landscape ? "row" : "column";
                $b4e14b6b8da86996$var$captures.style.flexDirection = landscape ? "column" : "row";
                if (landscape) {
                    $b4e14b6b8da86996$var$modalBottomWrapper.style.flexDirection = "column";
                    $b4e14b6b8da86996$var$modalBottomWrapper.style.height = window.innerHeight + "px";
                    $b4e14b6b8da86996$var$modalBottomWrapper.style.width = "";
                } else {
                    $b4e14b6b8da86996$var$modalBottomWrapper.style.flexDirection = "row";
                    $b4e14b6b8da86996$var$modalBottomWrapper.style.height = "";
                    $b4e14b6b8da86996$var$modalBottomWrapper.style.width = window.innerWidth + "px";
                }
            }
            const cssWidth = width + "px";
            const cssHeight = height + "px";
            if (landscape) {
                img.style.width = "";
                img.style.height = cssHeight;
                scale = window.innerHeight / data.height;
            } else {
                img.style.width = cssWidth;
                img.style.height = "";
                scale = window.innerWidth / data.width;
            }
            imgCrop.style.width = imgCrop.style.minWidth = cssWidth;
            imgCrop.style.height = imgCrop.style.minHeight = cssHeight;
            latestDims = false;
            paintLines();
        };
        updateImageDimensions();
        $b4e14b6b8da86996$var$captures.appendChild(imgCrop);
        const offResize = $b4e14b6b8da86996$var$onResize(updateImageDimensions);
        cbs.push((check)=>{
            if (check) {
                $b4e14b6b8da86996$var$pages.push({
                    data: data,
                    quad: quad,
                    img: img
                });
                $b4e14b6b8da86996$var$doneWrapper.style.opacity = "";
                if (isLast) {
                    if (img.width > img.height) {
                        img.style.height = $b4e14b6b8da86996$var$pastWrapper.style.height;
                        img.style.width = "";
                    } else {
                        img.style.height = "";
                        img.style.width = $b4e14b6b8da86996$var$pastWrapper.style.width;
                    }
                    while($b4e14b6b8da86996$var$pastWrapper.lastChild != $b4e14b6b8da86996$var$past)$b4e14b6b8da86996$var$pastWrapper.removeChild($b4e14b6b8da86996$var$pastWrapper.lastChild);
                    $b4e14b6b8da86996$var$pastWrapper.appendChild(img);
                }
            }
            offResize();
            $b4e14b6b8da86996$var$captures.removeChild(imgCrop);
        });
    }
    return new Promise((resolve)=>{
        const onDone = ()=>finish(true);
        const onCancel = ()=>finish(false);
        $b4e14b6b8da86996$var$modalCancel.addEventListener("click", onCancel);
        $b4e14b6b8da86996$var$modalDone.addEventListener("click", onDone);
        const finish = (check)=>{
            $b4e14b6b8da86996$var$modalDone.removeEventListener("click", onDone);
            $b4e14b6b8da86996$var$modalCancel.removeEventListener("click", onCancel);
            $b4e14b6b8da86996$var$modal.style.display = "none";
            for (const cb of cbs)cb(check);
            resolve(check);
        };
    });
};
const $b4e14b6b8da86996$var$isLandscape = (aspectRatio)=>window.innerWidth > window.innerHeight * aspectRatio;
const $b4e14b6b8da86996$var$calcDimensions = (aspectRatio, maxRatio)=>{
    const landscape = $b4e14b6b8da86996$var$isLandscape(aspectRatio);
    const height = landscape ? window.innerHeight : Math.floor(Math.min(window.innerWidth * aspectRatio, window.innerHeight * maxRatio));
    const width = landscape ? Math.floor(Math.min(window.innerHeight * aspectRatio, window.innerWidth * maxRatio)) : window.innerWidth;
    return {
        width: width,
        height: height
    };
};
const $b4e14b6b8da86996$var$sideWrappers = [
    $b4e14b6b8da86996$var$topWrapper,
    $b4e14b6b8da86996$var$bottomWrapper
];
const $b4e14b6b8da86996$var$topElems = [
    $b4e14b6b8da86996$var$flashWrapper,
    $b4e14b6b8da86996$var$qualityWrapper,
    $b4e14b6b8da86996$var$githubWrapper,
    $b4e14b6b8da86996$var$selectWrapper,
    $b4e14b6b8da86996$var$pastWrapper
];
const $b4e14b6b8da86996$var$bottomElems = [
    $b4e14b6b8da86996$var$doneWrapper,
    $b4e14b6b8da86996$var$uploadWrapper
];
const $b4e14b6b8da86996$var$allElems = $b4e14b6b8da86996$var$topElems.concat($b4e14b6b8da86996$var$bottomElems, $b4e14b6b8da86996$var$shutter);
const $b4e14b6b8da86996$var$startStream = async (device)=>{
    const maxRes = await $b4e14b6b8da86996$var$getMaxRes(device);
    let aspectRatio = maxRes.width / maxRes.height;
    const landscape = $b4e14b6b8da86996$var$isLandscape(aspectRatio);
    const { width: width, height: height } = $b4e14b6b8da86996$var$calcDimensions(aspectRatio, 0.84);
    const cssHeight = height + "px";
    const cssWidth = width + "px";
    $b4e14b6b8da86996$var$previewCrop.style.width = $b4e14b6b8da86996$var$previewCrop.style.minWidth = cssWidth;
    $b4e14b6b8da86996$var$previewCrop.style.height = $b4e14b6b8da86996$var$previewCrop.style.minHeight = cssHeight;
    $b4e14b6b8da86996$var$root.style.width = window.innerWidth + "px";
    $b4e14b6b8da86996$var$root.style.height = window.innerHeight + "px";
    for (const sideWrapper of $b4e14b6b8da86996$var$sideWrappers)if (landscape) {
        sideWrapper.style.flexDirection = "column";
        sideWrapper.style.height = window.innerHeight + "px";
        sideWrapper.style.width = "";
    } else {
        sideWrapper.style.flexDirection = "row";
        sideWrapper.style.height = "";
        sideWrapper.style.width = window.innerWidth + "px";
    }
    for (const topElem of $b4e14b6b8da86996$var$topElems)topElem.style.width = topElem.style.height = (landscape ? window.innerWidth : window.innerHeight) * 0.03 + "px";
    for (const bottomElem of $b4e14b6b8da86996$var$bottomElems)bottomElem.style.width = bottomElem.style.height = (landscape ? window.innerWidth : window.innerHeight) * 0.035 + "px";
    for (const elem of $b4e14b6b8da86996$var$allElems)elem.style.margin = (landscape ? window.innerWidth : window.innerHeight) * 0.02 + "px";
    $b4e14b6b8da86996$var$shutter.style.width = $b4e14b6b8da86996$var$shutter.style.height = (landscape ? window.innerWidth : window.innerHeight) * 0.05 + "px";
    const pastBorderSize = (landscape ? window.innerWidth : window.innerHeight) * 0.002 + "px";
    $b4e14b6b8da86996$var$pastWrapper.style.borderRadius = pastBorderSize;
    $b4e14b6b8da86996$var$pastWrapper.style.border = pastBorderSize + " solid white";
    if (landscape) {
        $b4e14b6b8da86996$var$preview.style.height = cssHeight;
        $b4e14b6b8da86996$var$preview.style.width = "";
        $b4e14b6b8da86996$var$root.style.flexDirection = "row";
    } else {
        $b4e14b6b8da86996$var$preview.style.height = "";
        $b4e14b6b8da86996$var$preview.style.width = cssWidth;
        $b4e14b6b8da86996$var$root.style.flexDirection = "column";
    }
    const constraints = {
        width: maxRes.width,
        height: maxRes.height,
        deviceId: {
            exact: maxRes.deviceId
        }
    };
    const stream = await navigator.mediaDevices.getUserMedia({
        video: constraints
    });
    const videoTrack = stream.getVideoTracks()[0];
    const capabilities = videoTrack.getCapabilities();
    $b4e14b6b8da86996$var$flashWrapper.style.display = capabilities.torch ? "" : "none";
    $b4e14b6b8da86996$var$preview.srcObject = stream;
    let newElems = [];
    const clearNewElems = ()=>{
        for (const elem of newElems)$b4e14b6b8da86996$var$previewDoc.removeChild(elem);
        newElems.length = 0;
    };
    const onMetadata = ()=>{
        const scale = landscape ? window.innerHeight / $b4e14b6b8da86996$var$preview.videoHeight : window.innerWidth / $b4e14b6b8da86996$var$preview.videoWidth;
        const docPreview = async ()=>{
            let quad;
            const ts = performance.now();
            if ($b4e14b6b8da86996$var$modal.style.display == "none") quad = await (0, $191e7775e3189472$export$c5fefc891e91de4b)(await (0, $aa7f0fbc084e0a0e$export$7a171f172be0782e)(await cap.grabFrame()), true);
            clearNewElems();
            if (docPreviewTimeout != -1) {
                if (quad) newElems = [
                    $b4e14b6b8da86996$var$previewDoc.appendChild($b4e14b6b8da86996$var$line(quad.a, quad.b, scale)),
                    $b4e14b6b8da86996$var$previewDoc.appendChild($b4e14b6b8da86996$var$line(quad.b, quad.c, scale)),
                    $b4e14b6b8da86996$var$previewDoc.appendChild($b4e14b6b8da86996$var$line(quad.c, quad.d, scale)),
                    $b4e14b6b8da86996$var$previewDoc.appendChild($b4e14b6b8da86996$var$line(quad.d, quad.a, scale))
                ];
                docPreviewTimeout = setTimeout(docPreview, Math.max(250 - performance.now() + ts, 0));
            }
        };
        docPreviewTimeout = setTimeout(docPreview, 0);
    };
    $b4e14b6b8da86996$var$preview.addEventListener("loadedmetadata", onMetadata);
    const cap = new ImageCapture(videoTrack);
    let hd = Object.prototype.toString.call(cap) == "[object ImageCapture]";
    $b4e14b6b8da86996$var$qualityWrapper.style.display = hd ? "" : "none";
    $b4e14b6b8da86996$var$qualityImg.src = (0, (/*@__PURE__*/$parcel$interopDefault($009ec47ee18c0b40$exports)));
    const onQualityClick = ()=>{
        hd = !hd;
        $b4e14b6b8da86996$var$qualityImg.src = hd ? (0, (/*@__PURE__*/$parcel$interopDefault($009ec47ee18c0b40$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($954630f75b1da243$exports)));
    };
    $b4e14b6b8da86996$var$quality.addEventListener("click", onQualityClick);
    let docPreviewTimeout = -1;
    const shutterFlash = ()=>{
        $b4e14b6b8da86996$var$preview.style.opacity = "0";
        setTimeout(()=>$b4e14b6b8da86996$var$preview.style.opacity = "", 50);
    };
    const onShutterClick = async ()=>{
        if ($b4e14b6b8da86996$var$shutter.style.opacity == "") {
            $b4e14b6b8da86996$var$shutter.style.opacity = "0.5";
            shutterFlash();
            try {
                const photo = hd ? await cap.takePhoto() : await cap.grabFrame();
                await $b4e14b6b8da86996$var$processPhotos([
                    photo
                ]);
            } catch (e) {}
            $b4e14b6b8da86996$var$shutter.style.opacity = "";
        }
    };
    $b4e14b6b8da86996$var$shutter.addEventListener("click", onShutterClick);
    let torch = false;
    $b4e14b6b8da86996$var$flashImg.src = (0, (/*@__PURE__*/$parcel$interopDefault($bb74cf2efca2bea5$exports)));
    const onFlashClick = async ()=>{
        try {
            torch = !torch;
            await videoTrack.applyConstraints({
                advanced: [
                    {
                        torch: torch
                    }
                ]
            });
            $b4e14b6b8da86996$var$flashImg.src = torch ? (0, (/*@__PURE__*/$parcel$interopDefault($5680d29e5f9eab67$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($bb74cf2efca2bea5$exports)));
        } catch (e) {}
    };
    $b4e14b6b8da86996$var$flash.addEventListener("click", onFlashClick);
    return {
        deviceId: maxRes.deviceId,
        close () {
            clearTimeout(docPreviewTimeout);
            docPreviewTimeout = -1;
            $b4e14b6b8da86996$var$shutter.removeEventListener("click", onShutterClick);
            $b4e14b6b8da86996$var$flash.removeEventListener("click", onFlashClick);
            $b4e14b6b8da86996$var$quality.removeEventListener("click", onQualityClick);
            $b4e14b6b8da86996$var$preview.removeEventListener("loadedmetadata", onMetadata);
            $b4e14b6b8da86996$var$preview.pause();
            for (const track of stream.getTracks())track.stop();
        }
    };
};
const $b4e14b6b8da86996$var$onLoad = async ()=>{
    let stream = await $b4e14b6b8da86996$var$startStream(localStorage.getItem("defaultDevice"));
    const updateBold = ()=>{
        for (const option of $b4e14b6b8da86996$var$select.options)option.style.fontWeight = "";
        $b4e14b6b8da86996$var$select.selectedOptions[0].style.fontWeight = "bold";
    };
    for (const device of (await navigator.mediaDevices.enumerateDevices()))if (device.kind == "videoinput") {
        const option = document.createElement("option");
        option.value = device.deviceId;
        option.label = device.label;
        $b4e14b6b8da86996$var$select.appendChild(option);
    }
    $b4e14b6b8da86996$var$select.value = stream.deviceId;
    updateBold();
    const update = async ()=>{
        updateBold();
        stream.close();
        $b4e14b6b8da86996$var$select.disabled = true;
        localStorage.setItem("defaultDevice", $b4e14b6b8da86996$var$select.value);
        stream = await $b4e14b6b8da86996$var$startStream($b4e14b6b8da86996$var$select.value);
        $b4e14b6b8da86996$var$select.disabled = false;
    };
    $b4e14b6b8da86996$var$select.onchange = update;
    $b4e14b6b8da86996$var$onResize(update);
    $b4e14b6b8da86996$var$upload.onchange = async ()=>{
        $b4e14b6b8da86996$var$shutter.style.opacity = "0.5";
        await $b4e14b6b8da86996$var$processPhotos([
            ...$b4e14b6b8da86996$var$upload.files
        ]);
        $b4e14b6b8da86996$var$shutter.style.opacity = "";
    };
    $b4e14b6b8da86996$var$done.onclick = async ()=>{
        if ($b4e14b6b8da86996$var$pages.length) {
            $b4e14b6b8da86996$var$doneWrapper.style.opacity = "0.5";
            while($b4e14b6b8da86996$var$pastWrapper.lastChild != $b4e14b6b8da86996$var$past)$b4e14b6b8da86996$var$pastWrapper.removeChild($b4e14b6b8da86996$var$pastWrapper.lastChild);
            (0, $aa7f0fbc084e0a0e$export$24422be91ad4011f)(new Blob([
                await (0, $98ce8732f7dffb75$export$99fdcdff3bb1ad24)(await Promise.all($b4e14b6b8da86996$var$pages.map(({ data: data, quad: quad })=>(0, $191e7775e3189472$export$ab8ba24d4c0c8986)(data, quad, 1224, true))))
            ]), "out.pdf");
            $b4e14b6b8da86996$var$pages.length = 0;
        }
    };
    $b4e14b6b8da86996$var$past.onclick = async ()=>{
        if ($b4e14b6b8da86996$var$pages.length) {
            const currPages = $b4e14b6b8da86996$var$pages.slice();
            $b4e14b6b8da86996$var$pages.length = 0;
            if (!await $b4e14b6b8da86996$var$processPhotos(currPages)) {
                $b4e14b6b8da86996$var$pages.push(...currPages);
                const { img: img } = currPages[currPages.length - 1];
                if (img.width > img.height) {
                    img.style.height = $b4e14b6b8da86996$var$pastWrapper.style.height;
                    img.style.width = "";
                } else {
                    img.style.height = "";
                    img.style.width = $b4e14b6b8da86996$var$pastWrapper.style.width;
                }
                while($b4e14b6b8da86996$var$pastWrapper.lastChild != $b4e14b6b8da86996$var$past)$b4e14b6b8da86996$var$pastWrapper.removeChild($b4e14b6b8da86996$var$pastWrapper.lastChild);
                $b4e14b6b8da86996$var$pastWrapper.appendChild(img);
            }
        }
    };
};
$b4e14b6b8da86996$var$onLoad();
var $6d2b58ea9d1b18f4$exports = {};

$6d2b58ea9d1b18f4$exports = new URL("workers/" + (parcelRequire("27Lyk")).resolve("drXuR"), import.meta.url).toString();


navigator.serviceWorker.register($6d2b58ea9d1b18f4$exports);


//# sourceMappingURL=index.ec5a4b7d.js.map
